export const COLORS = {
  Black: "#111111",
  White: "#f4f4f4",
  Red: "#d62828",
  Blue: "#2f5bd8",
  Green: "#2f8f4e",
  Pink: "#ef6aa6",
  Purple: "#7b4bd1",
  Yellow: "#f2c94c",
  Orange: "#f2994a",
  Gray: "#8a8a8f",
  Brown: "#7a4e2d",
  Silver: "linear-gradient(135deg,#f0f0f0,#9a9a9a 55%,#e5e5e5)",
  Gold: "linear-gradient(135deg,#f6dd8f,#b8892e 55%,#f1d27a)",
  Clear: "repeating-conic-gradient(#d4d4d8 0% 25%, #ffffff 0% 50%) 50% / 8px 8px",
};
export const COLOR_NAMES = Object.keys(COLORS);

export const Swatch = ({ name, size = 16, className = "" }) => (
  <span
    title={name}
    className={`inline-block rounded-full border border-white/20 ${className}`}
    style={{ width: size, height: size, background: COLORS[name] || "#666" }}
  />
);
